// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type VoidPOsStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type VoidPOsStepQuery = { __typename?: 'Query', bidContractRevision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, revisions: Array<{ __typename?: 'BidContractRevision', id: string, commitments: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, statusText: string, costChangeInCents: number, blueprintUrl: { __typename?: 'Url', path: string }, project: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }, costCodes: Array<{ __typename?: 'CostCode', id: string, number: string }>, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, potentialBidContractRevisions: Array<{ __typename?: 'PotentialBidContractRevision', totalCostInCents: number, bidContractRevision: { __typename?: 'BidContractRevision', id: string, version: string } }>, preferredBidContractRevision?: { __typename?: 'PotentialBidContractRevision', totalCostInCents: number, bidContractRevision: { __typename?: 'BidContractRevision', id: string } } | null | undefined, eventuallyVoidedBy?: { __typename?: 'Commitment', id: string, bidContractRevision?: { __typename?: 'BidContractRevision', id: string } | null | undefined } | null | undefined, canBeVoided: { __typename?: 'PotentialOperation2', allowed: boolean } }> }> } } };

export type VoidPOsStep_CommitmentFragment = { __typename?: 'Commitment', id: string, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, statusText: string, costChangeInCents: number, blueprintUrl: { __typename?: 'Url', path: string }, project: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }, costCodes: Array<{ __typename?: 'CostCode', id: string, number: string }>, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, potentialBidContractRevisions: Array<{ __typename?: 'PotentialBidContractRevision', totalCostInCents: number, bidContractRevision: { __typename?: 'BidContractRevision', id: string, version: string } }>, preferredBidContractRevision?: { __typename?: 'PotentialBidContractRevision', totalCostInCents: number, bidContractRevision: { __typename?: 'BidContractRevision', id: string } } | null | undefined, eventuallyVoidedBy?: { __typename?: 'Commitment', id: string, bidContractRevision?: { __typename?: 'BidContractRevision', id: string } | null | undefined } | null | undefined, canBeVoided: { __typename?: 'PotentialOperation2', allowed: boolean } };

export const VoidPOsStep_CommitmentFragmentDoc = gql`
    fragment VoidPOsStep_Commitment on Commitment {
  id
  accountingNumber
  blueprintUrl {
    path
  }
  project {
    id
    name
  }
  costCodes {
    id
    number
  }
  executionDate
  status
  statusText
  bidContractRevision {
    id
    version
  }
  costChangeInCents
  potentialBidContractRevisions {
    bidContractRevision {
      id
      version
    }
    totalCostInCents
  }
  preferredBidContractRevision {
    bidContractRevision {
      id
    }
    totalCostInCents
  }
  eventuallyVoidedBy {
    id
    bidContractRevision {
      id
    }
  }
  canBeVoided {
    allowed
  }
}
    `;
export const VoidPOsStepDocument = gql`
    query VoidPOsStep($id: ID!) {
  bidContractRevision(id: $id) {
    id
    bidContract {
      id
      revisions {
        id
        commitments {
          ...VoidPOsStep_Commitment
        }
      }
    }
  }
}
    ${VoidPOsStep_CommitmentFragmentDoc}`;

/**
 * __useVoidPOsStepQuery__
 *
 * To run a query within a React component, call `useVoidPOsStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoidPOsStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoidPOsStepQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVoidPOsStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VoidPOsStepQuery, VoidPOsStepQueryVariables> & ({ variables: VoidPOsStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VoidPOsStepQuery, VoidPOsStepQueryVariables>(VoidPOsStepDocument, options);
      }
export function useVoidPOsStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VoidPOsStepQuery, VoidPOsStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VoidPOsStepQuery, VoidPOsStepQueryVariables>(VoidPOsStepDocument, options);
        }
export function useVoidPOsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VoidPOsStepQuery, VoidPOsStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VoidPOsStepQuery, VoidPOsStepQueryVariables>(VoidPOsStepDocument, options);
        }
export type VoidPOsStepQueryHookResult = ReturnType<typeof useVoidPOsStepQuery>;
export type VoidPOsStepLazyQueryHookResult = ReturnType<typeof useVoidPOsStepLazyQuery>;
export type VoidPOsStepSuspenseQueryHookResult = ReturnType<typeof useVoidPOsStepSuspenseQuery>;
export type VoidPOsStepQueryResult = Apollo.QueryResult<VoidPOsStepQuery, VoidPOsStepQueryVariables>;